import React from "react";
import PropTypes from "prop-types";
import "../../styles/CardTitle.scss";
const CardTitle = (props) => {
    const { icon, title, sabTitle, setModalShow } = props;
    const iconStyle = `${icon} card-title__icon`;

    
    return (
        <div className="d-flex align-items-center mt-9">
            <i className={iconStyle} />
            <div className="card-title">{title}</div>
            {sabTitle && (
                <div data-testid="card-sub-title" className="card-sub-title" onClick={() => {setModalShow(true)}}>{sabTitle}</div>
            )}
        </div>
    )
};

CardTitle.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string
}

export default CardTitle;